export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.hamburger').on('click', function() {
      $(this).toggleClass('is-active');
      $('.menu-header-menu-burger-container').slideToggle(200);
      if($(this).hasClass('is-active')) {
        $('body').css('overflow', 'hidden');
      } else {
        $('body').css('overflow', 'visible');
      }
    });

    let existingHTML = $('.menu-header-menu-burger-container').html();

    $('.menu-header-menu-burger-container').html(existingHTML +
    '<div class="contact-bb">\n' +
      '<div class="content">\n' +
        '<a href="tel:0701913770311" class="text-white">+44 (0)191 377 0311</a><br/>\n' +
        '<a href="mailto:info@bowburnhallhotel.co.uk">info@bowburnhallhotel.co.uk</a>\n' +
      '</div>\n' +
      '<div class="content mt-md-2">\n' +
        '<p class="m-0 text-white">Bowburn Hall Hotel</p>\n' +
        '<p class="text-white">Bowburn, Durham, DH6 5NH</p>\n' +
      '</div>\n' +
      '<div class="content">\n' +
        '<a data-toggle=\'modal\' data-target=\'#contactBowburn\' href="#contactBowburn" class="btn-standard bb-gold-bg">Get in touch</a>' +
      '</div>\n' +
      '<div class="content">\n' +
          '<div class="social-media-links-block menu-links-block">\n' +
            '<a target="_blank" href="https://www.facebook.com/BowburnHallHotel/" class="ml-0 ml-md-2 menu-links"><i class="fab fa-facebook-square"></i></a>\n' +
            '<a target="_blank" href="https://www.instagram.com/bowburnhallhotel/" class="ml-2 ml-md-2 menu-links"><i class="fab fa-instagram"></i></a>\n' +
            '<a target="_blank" href="https://www.tripadvisor.co.uk/Hotel_Review-g190832-d295980-Reviews-Bowburn_Hall-Durham_County_Durham_England.html?m=19905" class="ml-2 ml-md-2 menu-links"><i class="fab fa-tripadvisor"></i></a>\n' +
          '</div>\n' +
        '</div>\n' +
      '</div>');

    if($(window).width() > 991) {
      $('.hover-block-wrapper__foreground').mouseover(function () {
        // Enter
        let element = $(this).find('.foreground-section__background');
        let outer_element = $('.hover-block-wrapper__background .background__section');
        let content = $(this).find('.foreground-section__content-inner__content .foreground__description');
        let content_bg = $(this).find('.foreground-section__content-inner__content');
        let content_link = $(this).find('.foreground-section__content-inner__content a');
        let content_title = $(this).find('.foreground-section__content-inner__content .foreground__title');
        let content_img = $(this).find('.foreground-section__content-inner__content img');

        outer_element.css('background-image', element.css('background-image'));
        outer_element.css('z-index', '10');
        content.addClass('mouseenter');
        content_img.addClass('mouseenter');
        content_title.addClass('mouseenter');
        content_bg.addClass('alphaIncrease');
        content_link.addClass('isVisible');

        outer_element.animate({
          opacity: 1,
        }, 250).finish();

      });

      $('.hover-block-wrapper__foreground').mouseout(function () {
        // Leave
        let outer_element = $('.hover-block-wrapper__background .background__section');
        let content = $(this).find('.foreground-section__content-inner__content .foreground__description');
        let content_bg = $(this).find('.foreground-section__content-inner__content');
        let content_link = $(this).find('.foreground-section__content-inner__content a');
        let content_title = $(this).find('.foreground-section__content-inner__content .foreground__title');
        let content_img = $(this).find('.foreground-section__content-inner__content img');

        content.removeClass('mouseenter');
        content_img.removeClass('mouseenter');
        content_title.removeClass('mouseenter');
        content_bg.removeClass('alphaIncrease');
        content_link.removeClass('isVisible');

        outer_element.animate({
          opacity: 0,
        }, 1000).finish();
        outer_element.css('z-index', '0');
      });
    }

    $(document.body).on('touchmove', onScroll);
    $(window).on('scroll', onScroll);
    function onScroll() {
      let bookbtn = $('.header-wrapper').find('.btn-booking');

      if (window.scrollY > 200) {
        bookbtn.addClass('isFixed');
        bookbtn.addClass('noWidthFixed');
      } else {
        bookbtn.removeClass('noWidthFixed');
        bookbtn.removeClass('isFixed');
      }
    }

    $(window).scroll(function(){
      $('#scroll-down').css('opacity', 1 - $(window).scrollTop() / 500);
      if($(window).width() < 1024) {
        $('#scroll-down').css('opacity', 1 - $(window).scrollTop() / 1000);
      }
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js